// vms-configurator-mcp.js: WebMCP tools for the ceiling configurator. Notes: reports/webmcp-configurator-guidance-2026-09-27/rounds/MCP-SOURCE-NOTES.md
(function () {
  'use strict';

  var VMS_PAGE_TOOLS = (typeof window !== 'undefined' && window)
    ? (window.VMSPageTools = window.VMSPageTools || { version: 1, tools: [] })
    : null;
  if (VMS_PAGE_TOOLS && !VMS_PAGE_TOOLS.register) {
    VMS_PAGE_TOOLS.register = function (tool) {
      if (!tool || typeof tool.name !== 'string') return;
      var idx = -1;
      for (var i = 0; i < VMS_PAGE_TOOLS.tools.length; i++) { if (VMS_PAGE_TOOLS.tools[i].name === tool.name) { idx = i; break; } }
      if (idx >= 0) VMS_PAGE_TOOLS.tools[idx] = tool; else VMS_PAGE_TOOLS.tools.push(tool);
      try { document.dispatchEvent(new CustomEvent('vms:page-tools-changed')); } catch (e) { }
    };
    VMS_PAGE_TOOLS.unregister = function (name) {
      var before = VMS_PAGE_TOOLS.tools.length;
      var kept = [];
      for (var i = 0; i < VMS_PAGE_TOOLS.tools.length; i++) { if (VMS_PAGE_TOOLS.tools[i].name !== name) kept.push(VMS_PAGE_TOOLS.tools[i]); }
      VMS_PAGE_TOOLS.tools = kept;
      if (VMS_PAGE_TOOLS.tools.length !== before) { try { document.dispatchEvent(new CustomEvent('vms:page-tools-changed')); } catch (e) { } }
    };
    VMS_PAGE_TOOLS.list = function () { return VMS_PAGE_TOOLS.tools.slice(); };
  }

  function page() { return (typeof window !== 'undefined' && window.VMSConfiguratorPage) || null; }

  var ORIGIN = 'https://videomountstore.com';
  var PHONE = '800-585-8795';
  function absUrl(u) { return (typeof u === 'string' && u.indexOf('/') === 0) ? ORIGIN + u : u; }
  function absImg(u) { return (typeof u === 'string' && u.indexOf('//') === 0) ? 'https:' + u : absUrl(u); }
  function absObjUrl(o) {
    if (!o || typeof o !== 'object') return;
    if (typeof o.url === 'string') o.url = absUrl(o.url);
    if (typeof o.image_url === 'string') o.image_url = absImg(o.image_url);
  }
  function absList(a) { if (Array.isArray(a)) a.forEach(absObjUrl); return a; }
  function absolutize(r) {
    if (!r || typeof r !== 'object') return r;
    if (typeof r.share_url === 'string') r.share_url = absUrl(r.share_url);
    if (typeof r.cart_url === 'string') r.cart_url = absUrl(r.cart_url);
    absObjUrl(r.plate); absObjUrl(r.head);
    absList(r.plates); absList(r.heads); absList(r.eligible_heads); absList(r.alternatives); absList(r.added);
    if (Array.isArray(r.builds)) r.builds.forEach(function (b) { if (b) absList(b.parts); });
    return r;
  }

  function rejectUnknownKeys(a, allowed) {
    if (!a || typeof a !== 'object') return null;
    for (var k in a) {
      if (!Object.prototype.hasOwnProperty.call(a, k)) continue;
      if (allowed.indexOf(k) === -1) {
        return 'This tool does not take "' + k + '". The keys it accepts are: ' + allowed.join(', ') + '.';
      }
    }
    return null;
  }

  function normVesa(s) {
    if (typeof s !== 'string') return null;
    var m = s.toLowerCase().replace(/\s+/g, '').replace(/mm/g, '').match(/^(\d+)x(\d+)$/);
    return m ? (m[1] + 'x' + m[2]) : null;
  }

  function textResult(payload) {
    var text = (typeof payload === 'string') ? payload : JSON.stringify(payload);
    var r = { content: [{ type: 'text', text: text }] };
    if (payload && typeof payload === 'object') r.structuredContent = JSON.parse(text);
    return r;
  }

  function num(v) { return (typeof v === 'number' && isFinite(v)) ? v : null; }
  function posNum(v) { var n = num(v); return (n !== null && n > 0) ? n : null; }
  function nonNegNum(v) { var n = num(v); return (n !== null && n >= 0) ? n : null; }
  function inRange(v, lo, hi) { var n = num(v); return (n !== null && n >= lo && n <= hi) ? n : null; }
  function notReady() { throw new Error('The build configurator is not ready on this page yet.'); }

  function errMessage(e) { return (e && e.message) ? e.message : 'This tool could not run right now.'; }
  function adaptExecute(t) {
    return function (input) {
      try {
        var out = t.execute(input);
        if (out && typeof out.then === 'function') { return out.then(function (r) { return r; }, function (e) { return textResult(errMessage(e)); }); }
        return out;
      } catch (e) { return textResult(errMessage(e)); }
    };
  }

  function sc(t, d) { var o = { type: t }; if (d) o.description = d; return o; }
  function nn(d) { return sc(['number', 'null'], d); }
  function ns(d) { return sc(['string', 'null'], d); }
  function nb(d) { return sc(['boolean', 'null'], d); }
  function en(v, d) { var o = sc(v.indexOf(null) >= 0 ? ['string', 'null'] : 'string', d); o['enum'] = v; return o; }
  function ob(p, d, nul) { var o = sc(nul ? ['object', 'null'] : 'object', d); o.properties = p; return o; }
  function ar(i, d) { var o = sc('array', d); o.items = i; return o; }
  function root(p, req, any) { var o = { type: 'object', description: UNITS, properties: p, additionalProperties: true }; if (req) o.required = req; if (any) o.anyOf = any; return o; }
  function ext(a, b) { var o = {}, k; for (k in a) o[k] = a[k]; for (k in b) o[k] = b[k]; return o; }
  var UNITS = 'Prices US dollars, lengths inches (keys ending _in), weights pounds (_lb), angles degrees (_deg), VESA millimetres (_mm); URLs absolute; null means not known or not set.';
  var STR = sc('string'), BOOL = sc('boolean'), INT = sc('integer'), NUM = sc('number');
  var USD = nn(), AURL = ns(), LO_HI_TXT = ns('text "lo to hi"');
  var PLATE_P = { sku: STR, title: ns(), price: USD, url: AURL, type_id: ns('ceiling_type this plate belongs to'), type_label: ns(), type_conditions: ns(),
    adds_length_in: nn(), cheapest_in_type: BOOL, what_makes_it_different: ns(), mounting_holes: ns(),
    dimensions: ns(), cable_pass_through: ns(), tilt_angle: nn('degrees the plate pivots, 0 when fixed'), weight_capacity_lb: nn(), image_url: AURL };
  var HEAD_P = { sku: STR, title: ns(), price: USD, url: AURL, adds_length_in: nn(), screens: ns(), rotates: nb(),
    tilt_up_deg: nn(), tilt_down_deg: nn(), weight_capacity_lb: nn(), vesa_width_mm: LO_HI_TXT,
    vesa_height_mm: LO_HI_TXT, vesa_patterns: ar(STR, '"WxH" patterns it takes'), picker_blurb: ns(),
    screen_range_in: LO_HI_TXT, horizontal: sc('boolean', 'face-down head, length to the back of the screen'), image_url: AURL };
  var GIVEN = { takes_given_vesa: nb(), covers_given_weight: nb() };
  var HEADS = ar(ob(ext(HEAD_P, GIVEN)));
  var PART = ob({ sku: STR, title: ns(), quantity: INT, price: USD, line_total: USD, image_url: AURL });
  var CUR = en(['USD']);
  var LO_HI = { min: NUM, max: NUM };
  var BUILD = ob({ index: INT, label: ns(), roles: ar(STR), fixed: BOOL, finished_length_in: nn('fixed build only'),
    finished_length_range_in: ob(LO_HI, 'adjustable build only', true),
    adjustment_in: ob({ shorter: NUM, longer: NUM }, 'travel from the set length, adjustable only', true),
    parts: ar(PART), pipes: INT, couplers: INT, surcharge: USD, total: USD, addable: BOOL, note: ns() });
  var STEP = en(['done', 'open', 'locked']);
  // tv_placement (SPEC-THEME-tv-placement-2026-10-12.md 8): keys listed in assets/vms-tv-lookup.notes.md; no property map, the 8192 B schema cap.
  var GB_P = {
    view: en(['configured', 'incomplete']),
    steps: ob({ size: STEP, plate: STEP, head: STEP, length: STEP }),
    tv_size_in: nn('screen diagonal'), plate: ob(PLATE_P, null, true), head: ob(HEAD_P, null, true),
    drop_ceiling: nb(), tile_depth_in: nn('tiles below the structure, drop ceiling only'),
    length_in: nn('ceiling structure straight down to the point length_reference names'),
    length_reference: en(['mid-screen', 'back-of-screen', 'hole-center']),
    length_floor_in: nn('shortest allowed length'), length_floor_reason: ns('machine code'), length_floor_note: ns(),
    needs_tile_depth: BOOL, weight_rating: ob({ lb: NUM, limited_by: ar(STR, 'SKUs'), confident: BOOL }, 'the lower of plate and head', true),
    plates: ar(ob(PLATE_P)), builds: ar(BUILD), no_build_reason: en(['no_pipe_fits', 'no_adjustable_headroom', null]), no_build_note: ns(),
    eligible_heads: HEADS, share_url: AURL,
    tv_placement: sc(['object', 'null'], "the shopper's TV from the catalog or their measurements, and where its top and bottom edges sit"),
    length_choice: ob({ defaulted: sc('boolean', 'true when no length was given'), default_in: NUM, used_in: NUM, raised_to_floor: BOOL,
      range_in: ob(LO_HI), floor_note: ns(), stock_pipes_in: ar(NUM, 'fixed mast pipes, joined by couplers'),
      telescoping_in: ar(ob({ sku: STR, min: NUM, max: nn() })), note: ns('null when the shopper chose the length') }, 'the length used and the range to offer', true),
    heads: ar(ob(ext({ sku: STR, fits: BOOL }, GIVEN)), 'every head, shaped like eligible_heads items; fits = the TV size and any VESA and weight given; takes_given_vesa and covers_given_weight null when not given'),
    currency: CUR
  };
  var GB_REQ = ['view', 'steps', 'tv_size_in', 'plate', 'head', 'drop_ceiling', 'tile_depth_in', 'length_in', 'length_reference', 'length_floor_in',
    'length_floor_reason', 'length_floor_note', 'needs_tile_depth', 'weight_rating', 'plates', 'builds', 'no_build_reason', 'no_build_note', 'eligible_heads', 'share_url',
    'length_choice', 'heads', 'currency'];
  var OS_GET = root(GB_P, GB_REQ);
  var OS_CONFIGURE = root(ext(GB_P, {
    plates: ar(sc('object'), 'shaped like vms-get-build plates items'), eligible_heads: ar(sc('object'), 'shaped like vms-get-build eligible_heads items'),
    plate_auto_selected: BOOL, head_auto_selected: BOOL, no_head_reason: STR, head_from_url: BOOL,
    head_fit: ob({ vesa_checked: BOOL, weight_checked: BOOL }), handback: STR, build_weight_ok: BOOL, build_weight_note: STR,
    tile_depth_defaulted: BOOL, length_adjusted: ob({ requested: NUM, settled: NUM, reason: ns('machine code; rounded_to_half_inch for the half inch step'), note: ns(), unit: en(['inches']) }),
    ceiling_angle_deg: NUM, plate_note: sc('string', 'why the auto pick passed over a cheaper plate for this angle'), angle_note: STR,
    handoff: ob({ url: STR, tools: STR, why: STR }, 'refusal sloped_short_handoff: the slanted wall page'), handoff_threshold_in: NUM,
    refusal: en(['head_unknown', 'head_does_not_fit_size', 'head_vesa_mismatch', 'head_weight_exceeded', 'plate_unknown', 'plate_type_mismatch', 'plate_does_not_fit_angle', 'tile_depth_without_drop_ceiling', 'ceiling_angle_without_sloped', 'sloped_short_handoff']),
    head_sku: STR, plate_sku: STR, message: STR, alternatives: ar(sc('object'), 'heads that fit (head refusals) or plates to pick (plate refusals), shaped like eligible_heads or plates items'), phone: STR
  }), null, [{ required: GB_REQ.concat('handback') }, { required: ['refusal', 'message', 'phone'] }]);
  var OS_ADD = root({
    ok: BOOL, added: ar(ob({ sku: ns(), title: ns(), quantity: INT, price: USD, line_total: USD, variant_id: sc(['integer', 'string']), image_url: AURL })),
    not_added: ar(ob({ sku: ns(), variant_id: sc(['integer', 'string']), quantity: INT })), total: USD, build_total: nn('page estimate'),
    finished_length: ns('"N in" or "lo to hi in"'), build_weight_ok: nb(), build_weight_note: ns(),
    drop_ceiling: ob({ enabled: BOOL, tile_depth_in: nn() }), build_property: ns(), config_id: STR, summary: ns(), remove_hint: ns(), cart_url: AURL,
    handback: STR, length_reference: ns('what finished_length is measured to'), share_url: AURL, currency: CUR
  }, ['ok', 'added', 'not_added', 'total', 'build_total', 'finished_length', 'build_weight_ok', 'build_weight_note', 'drop_ceiling', 'build_property', 'config_id', 'summary', 'remove_hint', 'cart_url',
    'handback', 'length_reference', 'share_url', 'currency']);
  var OS_REMOVE = root({
    ok: BOOL, config_id: ns(), removed: ar(ob({ sku: ns(), title: ns(), quantity: INT, variant_id: sc(['integer', 'string']), line_price: USD, config_id: ns() })),
    removed_total: USD, not_removed: ar(ob({ key: STR, sku: ns(), title: ns(), quantity: INT, config_id: ns() })),
    cart_after: ob({ item_count: INT, total_price: USD, builds_remaining: ar(STR, 'config ids') }), cart_url: AURL, handback: STR, currency: CUR
  }, ['ok', 'config_id', 'removed', 'removed_total', 'cart_after', 'cart_url', 'handback', 'currency']);

  var CEILING_TYPES = ['flat', 'sloped', 'uni', 'ibeam', 'truss'];

  var tools = [
    {
      name: 'vms-configure-build',
      annotations: { readOnlyHint: false, destructiveHint: false, idempotentHint: true },
      outputSchema: OS_CONFIGURE,
      description: 'Build a ceiling TV mount from the shopper\'s numbers in one call. Before calling, ask the shopper, in this order: (1) the TV\'s screen size (diagonal, inches); (2) the ceiling type; (3) the finished length, the shopper\'s choice and the biggest decision in the build; (4) the VESA pattern, for example 400x400; (5) the TV\'s weight in pounds; (6) whether it hangs under a drop (tile) ceiling, and the tile depth. The length runs from the ceiling structure straight down to the middle of the screen. Left out, the page uses 30 inches, or the shortest allowed length when that is longer: tell the shopper the length you used and that any length from length_floor_in to 200 inches is available. In results, length_in is the length built; length_floor_in is only the minimum. For a sloped ceiling, ask the ceiling angle and pass ceiling_angle_deg: the page picks a plate that pivots that far but sets the TV against a flat ceiling, and a length under 18 inches is REFUSED with a handoff to the slanted wall page, https://videomountstore.com/pages/tv-mount-for-slanted-wall, whose own vms-configure-build sets the TV against the actual slope. Every call is the WHOLE build; anything omitted resets to the page default. Required: tv_size_in and ceiling_type. Optional plate, head, VESA and weight refine the pick (see the schema). Returns the builds with parts and total, alternative heads, share_url (reopens this build; offer it) and a hand-back line. Ask before adding to the cart. Not read-only.',
      inputSchema: {
        type: 'object',
        properties: {
          tv_size_in: { type: 'number', minimum: 10, maximum: 120, multipleOf: 0.5, description: 'TV diagonal in inches, 10 to 120 (a whole number or a half; the page injects any size the list lacks).' },
          ceiling_type: { type: 'string', enum: ['flat', 'sloped', 'uni', 'ibeam', 'truss'], description: 'What the ceiling is (case-insensitive): "flat" (drywall with structure behind it, exposed wood joists, or a concrete deck), "sloped" (sloped, vaulted or cathedral ceilings), "uni" (metal building with strut / unistrut channel), "ibeam" (exposed steel I-beam), or "truss" (open web truss, bar joist, or stage / lighting truss).' },
          plate_sku: { type: 'string', description: 'Optional. A specific ceiling plate SKU from get-build\'s plates list (which carries each plate\'s full comparison chart). It must match ceiling_type. Leave out to use the cheapest plate of the type.' },
          head_sku: { type: 'string', description: 'Optional. A specific mounting head SKU (case-insensitive). Refused with the fitting alternatives if it does not fit the TV size, the VESA pattern or the weight. Leave out to use the cheapest head that fits, then call get-build for the alternatives.' },
          length_in: { type: 'number', minimum: 1, maximum: 200, default: 30, description: 'Optional, but ask for it: the finished length is the shopper\'s choice. Inches from the ceiling structure straight down to the middle of the screen, 1 to 200. Left out, the page uses 30 inches (or the shortest allowed length when that is longer). The page rounds to the nearest half inch and raises a length that would not clear the ceiling or the tiles, reported in length_adjusted; for a face-down head (DD-HEAD, measured to the back of the screen) the floor is the mounting head clearing the tiles, not the screen.' },
          drop_ceiling: { type: 'boolean', default: false, description: 'Optional. True if the mount attaches under a drop (suspended-tile) ceiling. Left out, it means NO drop ceiling (the page clears any tile depth).' },
          tile_depth_in: { type: 'number', minimum: 0, maximum: 200, description: 'Optional, 0 to 200, only with drop_ceiling true: how far the underside of the tiles hangs below the structure, in inches. Left out under a drop ceiling the page uses 12 inches; passed without drop_ceiling true it is refused.' },
          vesa_pattern: { type: 'string', pattern: '^\\s*\\d+\\s*(?:[mM][mM]\\s*)?[xX]\\s*\\d+\\s*(?:[mM][mM]\\s*)?$', description: 'Optional. The TV\'s VESA hole pattern as "WxH" in millimetres, e.g. "400x400". Filters the auto head pick, and with head_sku refuses a head that does not take it.' },
          tv_weight_lb: { type: 'number', exclusiveMinimum: 0, description: 'Optional. The TV\'s weight in pounds. Filters the auto head pick, and with head_sku refuses a head whose rating does not cover it. After the build is placed it is checked against the whole build rating (weight_rating.lb, the lower of the plate and the head): if the plate caps the build under the TV, build_weight_ok comes back false with build_weight_note naming the limiter and a heavier plate for this ceiling type when one exists, and the hand-back does not relay the build as fine.' },
          ceiling_angle_deg: { type: 'number', minimum: 0, maximum: 89, description: 'Optional, only with ceiling_type sloped: the ceiling angle in degrees, 0 (flat) to 89. Ask for it on a sloped ceiling. When given, the page picks only a sloped plate that pivots that far (CCA-1 to 60 degrees, 11CP006 to 83, 11AC005 to 90, and ANGLE-CEILING 90 from plumb one way and 4 the other, so mount it the right way round) and says why in plate_note; a named plate that does not is refused with the ones that do.' }
        },
        required: ['tv_size_in', 'ceiling_type'],
        additionalProperties: false
      },
      execute: function (args) {
        var p = page(); if (!p) return notReady();
        var a = args || {};
        var badKey = rejectUnknownKeys(a, ['tv_size_in', 'ceiling_type', 'plate_sku', 'head_sku', 'length_in', 'drop_ceiling', 'tile_depth_in', 'vesa_pattern', 'tv_weight_lb', 'ceiling_angle_deg']);
        if (badKey) throw new Error(badKey);
        var size = inRange(a.tv_size_in, 10, 120);
        if (size === null) throw new Error('tv_size_in: The TV size must be a number of inches from 10 to 120.');
        var ct = (typeof a.ceiling_type === 'string') ? a.ceiling_type.trim().toLowerCase() : '';
        if (CEILING_TYPES.indexOf(ct) === -1) throw new Error('ceiling_type: The ceiling type must be one of: flat, sloped, uni, ibeam, truss.');
        var opts = { tv_size_in: size, ceiling_type: ct };
        if (a.plate_sku != null) {
          if (typeof a.plate_sku !== 'string' || a.plate_sku.trim() === '') throw new Error('plate_sku: The plate SKU must be a non-empty text value, or leave it out to use the cheapest plate of the type.');
          opts.plate_sku = a.plate_sku;
        }
        if (a.head_sku != null) {
          if (typeof a.head_sku !== 'string' || a.head_sku.trim() === '') throw new Error('head_sku: The head SKU must be a non-empty text value, or leave it out to use the cheapest head that fits.');
          opts.head_sku = a.head_sku;
        }
        if (a.length_in != null) {
          var len = inRange(a.length_in, 1, 200);
          if (len === null) throw new Error('length_in: The finished length must be a number of inches from 1 to 200.');
          opts.length_in = len;
        }
        if (a.drop_ceiling != null) {
          if (typeof a.drop_ceiling !== 'boolean') throw new Error('drop_ceiling: The drop-ceiling answer must be true or false.');
          opts.drop_ceiling = a.drop_ceiling;
        }
        if (a.tile_depth_in != null) {
          var td = inRange(a.tile_depth_in, 0, 200);
          if (td === null) throw new Error('tile_depth_in: The tile depth must be a number of inches from 0 to 200.');
          if (a.drop_ceiling !== true) throw new Error('tile_depth_in: A tile depth only applies under a drop ceiling. Pass drop_ceiling true with the tile depth, or leave the tile depth out.');
          opts.tile_depth_in = td;
        }
        if (a.vesa_pattern != null) {
          var v = normVesa(a.vesa_pattern);
          if (v === null) throw new Error('vesa_pattern: The VESA pattern must read "WxH" in millimetres, for example "400x400".');
          opts.vesa_pattern = v;
        }
        if (a.tv_weight_lb != null) {
          var w = posNum(a.tv_weight_lb);
          if (w === null) throw new Error('tv_weight_lb: The TV weight must be a positive number of pounds.');
          opts.tv_weight_lb = w;
        }
        if (a.ceiling_angle_deg != null) {
          var ang = inRange(a.ceiling_angle_deg, 0, 89);
          if (ang === null) throw new Error('ceiling_angle_deg: The ceiling angle must be a number of degrees from 0 to 89.');
          if (ct !== 'sloped') throw new Error('ceiling_angle_deg: A ceiling angle only applies to ceiling_type sloped. Pass sloped with the angle, or leave the angle out.');
          opts.ceiling_angle_deg = ang;
        }
        return textResult(absolutize(p.configureBuild(opts)));
      }
    },
    {
      name: 'vms-get-build',
      annotations: { readOnlyHint: true },
      outputSchema: OS_GET,
      readOnlyHint: true,
      description: 'Get the current ceiling-mount build as JSON, to describe it or re-check after a change. Returns completeness, step states, TV size, plate and head with price, URL, image and specs, drop-ceiling state, the length used and its range (length_choice), the weight rating and limiter, every plate with its chart and every head with a fits flag, the recommended builds with parts, alternative heads and share_url. Prices are US dollars, lengths inches, angles degrees, weights pounds. Read-only.',
      inputSchema: { type: 'object', properties: {}, additionalProperties: false },
      execute: function (args) {
        var p = page(); if (!p) return notReady();
        var badKey = rejectUnknownKeys(args, []);
        if (badKey) throw new Error(badKey);
        return textResult(absolutize(p.getBuild()));
      }
    },
    {
      name: 'vms-add-to-cart',
      annotations: { readOnlyHint: false, destructiveHint: false, idempotentHint: false },
      outputSchema: OS_ADD,
      description: 'Ask the shopper before calling this. Adds a current build to the cart. build_index picks it: 0 is the recommended ADJUSTABLE build and the default, but a fixed-length build may be cheaper, so read builds[] first. Only a complete, buyable build; an unavailable or backordered part or a missing build number is refused. If a checked TV weight exceeds the build rating it REFUSES naming the limiter. Returns the lines added, total, config id, cart URL, build_weight_ok and share_url for the shopper.',
      inputSchema: {
        type: 'object',
        properties: {
          build_index: { type: 'integer', minimum: 0, default: 0, description: 'Which recommended build to add, 0 for the page\'s recommended adjustable (top) build. A fixed-length build may be cheaper; read builds[] first. Defaults to 0.' }
        },
        additionalProperties: false
      },
      execute: function (args) {
        var p = page(); if (!p) return notReady();
        var a = args || {};
        var badKey = rejectUnknownKeys(a, ['build_index']);
        if (badKey) throw new Error(badKey);
        var idx = 0;
        if (a.build_index != null) {
          var n = num(a.build_index);
          if (n === null || n < 0 || Math.floor(n) !== n) throw new Error('build_index: The build number must be a whole number, 0 or greater (0 is the recommended build).');
          idx = n;
        }
        return Promise.resolve(p.addToCart(idx))
          .catch(function () { return { ok: false, reason: 'This build could not be added to the cart right now. Call ' + PHONE + '.' }; })
          .then(function (r) {
            if (!r || !r.ok) throw new Error((r && r.reason) || 'This build cannot be added to the cart right now.');
            return textResult({ ok: true, added: absList(r.added), not_added: r.not_added, total: r.total, build_total: r.build_total,
              finished_length: r.finished_length, build_weight_ok: r.build_weight_ok, build_weight_note: r.build_weight_note,
              drop_ceiling: r.drop_ceiling, build_property: r.build_property,
              config_id: r.config_id, summary: r.summary, remove_hint: r.remove_hint, cart_url: absUrl(r.cart_url),
              handback: r.handback, length_reference: r.length_reference, share_url: absUrl(r.share_url), currency: 'USD' });
          });
      }
    },
    {
      name: 'vms-remove-build',
      annotations: { readOnlyHint: false, destructiveHint: true, idempotentHint: true },
      outputSchema: OS_REMOVE,
      description: 'Take a configured build back out of the cart, for a build added by mistake. Pass config_id to remove exactly that build\'s lines (the id vms-add-to-cart returned); leave it out to remove EVERY build added from the two VMS build pages. It only removes lines a build page added, never the shopper\'s other items. Returns the lines removed, the removed total, the cart after, the cart URL, and a hand-back line. A targeted line still present after a concurrent change is listed in not_removed[].',
      inputSchema: {
        type: 'object',
        properties: {
          config_id: { type: 'string', description: 'Optional. The build id (from add-to-cart\'s config_id) to remove. Leave out to remove every build in the cart.' }
        },
        additionalProperties: false
      },
      execute: function (args) {
        var p = page(); if (!p || typeof p.removeBuild !== 'function') return notReady();
        var a = args || {};
        var badKey = rejectUnknownKeys(a, ['config_id']);
        if (badKey) throw new Error(badKey);
        var cid = undefined;
        if (a.config_id != null) {
          if (typeof a.config_id !== 'string' || a.config_id.trim() === '') throw new Error('config_id: The config_id must be a non-empty text value, or leave it out to remove every build in the cart.');
          cid = a.config_id;
        }
        return Promise.resolve(p.removeBuild(cid))
          .catch(function () { return { ok: false, reason: 'This build could not be removed from the cart right now. Call ' + PHONE + '.' }; })
          .then(function (r) {
            if (!r || !r.ok) throw new Error((r && r.reason) || 'The build could not be removed from the cart right now.');
            return textResult({ ok: true, config_id: r.config_id, removed: r.removed, removed_total: r.removed_total,
              not_removed: r.not_removed, cart_after: r.cart_after, cart_url: absUrl(r.cart_url), handback: r.handback, currency: 'USD' });
          });
      }
    }
  ];

  if (VMS_PAGE_TOOLS) { for (var pti = 0; pti < tools.length; pti++) { VMS_PAGE_TOOLS.register(tools[pti]); } }

  var attachedTargets = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
  function attach(mc) {
    if (!mc || typeof mc.registerTool !== 'function') return 0;
    if (attachedTargets && attachedTargets.has(mc)) return 0;
    var n = 0;
    for (var i = 0; i < tools.length; i++) {
      var t = tools[i];
      try {
        var reg = { name: t.name, description: t.description, inputSchema: t.inputSchema, annotations: t.annotations, execute: adaptExecute(t) };
        if (t.readOnlyHint === true) reg.readOnlyHint = true;
        if (t.outputSchema) reg.outputSchema = t.outputSchema;
        mc.registerTool(reg);
        n++;
      } catch (e) { }
    }
    if (n > 0 && attachedTargets) attachedTargets.add(mc);
    return n;
  }

  if (typeof window !== 'undefined') {
    window.VMSConfiguratorMCP = { tools: tools, attach: attach };
    var done = false;
    function currentMC() {
      var doc = (window.document) || ((typeof document !== 'undefined') ? document : null);
      var nav = (window.navigator) || ((typeof navigator !== 'undefined') ? navigator : null);
      return (doc && doc.modelContext) || (nav && nav.modelContext) || null;
    }
    function tryAttachNow() {
      if (done) return true;
      var topLevel = (window.top === window.self);
      var secure = (typeof window.isSecureContext === 'undefined') ? true : !!window.isSecureContext;
      if (!topLevel || !secure) { done = true; return true; }
      var mc = currentMC();
      if (!mc || typeof mc.registerTool !== 'function') return false;
      attach(mc);
      done = true;
      return true;
    }
    try {
      if (!tryAttachNow()) {
        var onEvent = function () { tryAttachNow(); };
        if (window.document && window.document.addEventListener) { window.document.addEventListener('DOMContentLoaded', onEvent); }
        if (window.addEventListener) { window.addEventListener('load', onEvent); }
        var intervals = [500, 500, 1000, 2000, 4000, 8000, 15000];
        var scheduleRetry = function (i) {
          if (done || i >= intervals.length || typeof window.setTimeout !== 'function') return;
          window.setTimeout(function () { if (!tryAttachNow()) scheduleRetry(i + 1); }, intervals[i]);
        };
        scheduleRetry(0);
      }
    } catch (e) { }
  }
})();
